import apiClient from "../config/apiClient";


export const fetchProblemList = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=patient/${id}/diagnoses?group_by=code`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  